(function enableVelzeenAccountMenu() {
  function closeMenu(menu) {
    menu.removeAttribute('open');
    delete menu.dataset.vzClickOpen;
  }

  function closeOtherMenus(activeMenu) {
    document.querySelectorAll('.vz-account-menu[open]').forEach((menu) => {
      if (menu !== activeMenu) closeMenu(menu);
    });
  }

  function bindAccountMenu() {
    document.querySelectorAll('.vz-account-menu').forEach((menu) => {
      if (menu.dataset.vzAccountMenuBound === 'true') return;
      menu.dataset.vzAccountMenuBound = 'true';

      const summary = menu.querySelector('summary');
      const panel = menu.querySelector('.vz-account-menu__panel');

      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (menu.open && menu.dataset.vzClickOpen === 'true') {
          closeMenu(menu);
          return;
        }

        closeOtherMenus(menu);
        menu.setAttribute('open', '');
        menu.dataset.vzClickOpen = 'true';
      });

      panel?.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest('.vz-account-menu')) return;
    document.querySelectorAll('.vz-account-menu[open]').forEach(closeMenu);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.vz-account-menu[open]').forEach(closeMenu);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAccountMenu, { once: true });
  } else {
    bindAccountMenu();
  }

  const headerGroup = document.querySelector('#header-group');
  if (headerGroup) {
    new MutationObserver(bindAccountMenu).observe(headerGroup, {
      childList: true,
      subtree: true,
    });
  }
})();
